import { render, staticRenderFns } from "./Loaded.vue?vue&type=template&id=47484d0f"
import script from "./Loaded.vue?vue&type=script&lang=js"
export * from "./Loaded.vue?vue&type=script&lang=js"
import style0 from "./Loaded.vue?vue&type=style&index=0&id=47484d0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports